import { z } from "zod";

import {
  PystructMaterialBaseRequest,
  PystructMaterialBaseResponse,
  PystructQueueResponse,
  PystructRequest,
} from "../contracts/pystruct";
import { PredictionInputErrorItemSchema } from "../helpers/predictionErrorMetadata";
import { MaterialGradeType, QuoteRequestLineSchema, JobErrorCodeSchema } from "./PrismaZod";

export type PredictJobInputData = {
  jobId: string;
  companyId: string;
  quoteRequestLineId: string;
  materialGrade: MaterialGradeType;
  shouldSearchForRelevantMaterial: boolean;
  modelKey?: string;
};

export type ExtractInboundEmailJobInputData = PystructRequest & {
  jobId: string;
  companyId: string;
  quoteRequestId: string;
};

export type ExtractInboundEmailJobOutputData = PystructQueueResponse;

export type StructureMaterialBaseJobInputData = PystructMaterialBaseRequest & {
  jobId: string;
  companyId: string;
};

export type StructureMaterialBaseJobOutputData = PystructMaterialBaseResponse;

const PredictJobOutpoutDataSchema = z.discriminatedUnion("success", [
  z.object({
    success: z.literal(true),
    quoteRequestLine: QuoteRequestLineSchema,
  }),
  z.object({
    success: z.literal(false),
    error: z.object({
      errorCode: JobErrorCodeSchema,
      rawErrorMessage: z.string(),
      errorMetadata: z.array(PredictionInputErrorItemSchema),
    }),
  }),
]);

export type PredictJobOutpoutData = z.infer<typeof PredictJobOutpoutDataSchema>;
